// src/pages/DesktopPublishingServices.js
import React from 'react';
import { NavLink } from 'react-router-dom';

const DesktopPublishingServices = () => (
  <>
    {/* Breadcrumb Section */}
    <div
      className="optech-breadcrumb"
      style={{ backgroundImage: "url(/assets/images/breadcrumb/breadcrumb.png)" }}
    >
      <div className="container">
        <h1 className="post__title">Desktop Publishing Services</h1>
        <nav className="breadcrumbs">
          <ul>
            <li>
              <NavLink to="/services">AI Service</NavLink>
            </li>
            <li aria-current="page">Desktop Publishing Services</li>
          </ul>
        </nav>
        <p className="text-white pt-5">
          Desktop Publishing (DTP) is an essential process that molds text and visuals into a cohesive, reader-friendly layout. R A Inc’s DTP services address all facets of design and formatting, making certain your brochures, books, or corporate material communicate effectively and look polished.
        </p>
      </div>
    </div>

    {/* Service Section */}
    <div className="section optech-section-padding">
      <div className="container">
        <div className="row">
          {/* Left Column */}
          <div className="col-lg-8">
            <div className="optech-service-details-wrap">
              <img
                data-aos="fade-up"
                data-aos-duration="800"
                src="/assets/images/service/dtp.jpg"
                alt="Desktop Publishing Services"
                className="mb-4 w-100"
              />

              {/* Overview */}
              <div className="optech-service-details-item">
                <h3>Overview</h3>
                <p>
                  The essence of DTP lies in uniting editorial rigor with aesthetic judgment. Whether producing a product catalog or an internal corporate manual, consistent typography and uncluttered composition enhance readability.
                </p>
                <p>
                  For global undertakings, we may need to account for text expansion in translated versions, as well as the proper arrangement of right-to-left scripts or specialized characters.
                </p>
              </div>

              {/* Key DTP Services */}
              <div className="optech-service-details-item">
                <h3>Key DTP Services</h3>
                <div className="optech-icon-list">
                  <ul>
                    <li><i className="ri-check-line"></i><strong>Layout Design:</strong> Crafting organized pages to guide reader attention.</li>
                    <li><i className="ri-check-line"></i><strong>Cover Art:</strong> Creating visuals that reflect brand identity or thematic focus.</li>
                    <li><i className="ri-check-line"></i><strong>Graphics Development:</strong> Integrating infographics, icons, or charts.</li>
                    <li><i className="ri-check-line"></i><strong>Brochures & Catalogs:</strong> Presenting product lines in an appealing, easy-to-skim format.</li>
                    <li><i className="ri-check-line"></i><strong>Photo Editing:</strong> Adjusting colors, removing imperfections, and aligning imagery with the text.</li>
                    <li><i className="ri-check-line"></i><strong>Typesetting:</strong> Maintaining consistent style, spacing, and hierarchical text structure.</li>
                  </ul>
                </div>
              </div>

              {/* File Formats */}
              <div className="optech-service-details-item">
                <h3>Common DTP File Formats</h3>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Format</th>
                      <th>Usage</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>InDesign (.indd)</td>
                      <td>High-end print and digital layouts</td>
                    </tr>
                    <tr>
                      <td>PDF (.pdf)</td>
                      <td>Cross-platform sharing, universal readability</td>
                    </tr>
                    <tr>
                      <td>MS Publisher (.pub)</td>
                      <td>Quick marketing documents, smaller-scale projects</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Highlights */}
              <div className="optech-service-details-item">
                <h3>Highlights</h3>
                <ul className="list-unstyled">
                  <li><i className="ri-check-line"></i>Tailored formatting that adheres to brand style guides.</li>
                  <li><i className="ri-check-line"></i>Approaches suited for both digital presentations and physical print runs.</li>
                  <li><i className="ri-check-line"></i>We manage color spaces, bleed settings, and other print-specific details.</li>
                </ul>
              </div>

              {/* Conclusion */}
              <div className="optech-service-details-item">
                <h3>Conclusion</h3>
                <p>
                  DTP can elevate text, charts, and images to convey maximum clarity and professionalism. At R A Inc, our comprehensive approach to layout and design ensures you publish materials that not only inform but also engage the reader at every turn, making a memorable impression.
                </p>
              </div>
            </div>
          </div>

          {/* Sidebar Section */}
          <div className="col-lg-4">
            <div className="optech-service-sidebar">
              <div className="optech-service-menu">
                <ul>
                  {[
                    { name: 'Multimedia & DTP Services',       slug: '/multimedia-and-dtp-services' },
                    { name: 'Audio & Video Transcription',     slug: '/audio-and-video-transcription' },
                    { name: 'Desktop Publishing Services',     slug: '/desktop-publishing-services' },
                    { name: 'Subtitle Services',               slug: '/subtitling' },
                    { name: 'Multilingual Desktop Publishing', slug: '/multilingual-desktop-publishing' },
                    { name: 'Multimedia & DTP Tools',          slug: '/multimedia-and-dtp-tools' }
                  ].map(service => (
                    <li key={service.slug}>
                      <NavLink to={service.slug}>
                        {service.name} <i className="ri-arrow-right-up-line" />
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>

              <div
                className="optech-service-contact"
                data-aos="fade-up"
                data-aos-duration="800"
                style={{ backgroundImage: "url(/assets/images/service/bg.png)" }}
              >
                <div className="optech-service-contact-icon">
                  <img src="/assets/images/service/icon.svg" alt="" />
                </div>
                <h3>Need Professional DTP?</h3>
                <p>Partner with us to ensure your documents are not only informative but beautifully presented.</p>
                <NavLink className="optech-default-btn" data-text="Get in Touch" to="/contact-us">
                  <span className="btn-wraper">Get in Touch</span>
                </NavLink>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    {/* Call To Action Section */}
    <div
      className="section bg-cover optech-section-padding"
      style={{ backgroundImage: "url(/assets/images/cta/cta-bg2.png)" }}
    >
      <div className="container">
        <div className="optech-cta-wrap">
          <div className="optech-cta-content center">
            <h2>Let's Translate Your Vision Into Every Language</h2>
            <p>
              Whether you're expanding your business internationally or need multilingual content for local markets, we provide solutions tailored to your goals, audience, and tone.
            </p>
            <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
              <NavLink className="optech-default-btn" data-text="Let’s Start a Project" to="/contact-us">
                <span className="btn-wraper">Let’s Start a Project</span>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default DesktopPublishingServices;